import { Controller } from "@hotwired/stimulus"

// Colors a card's case-worker circle when it's the signed-in user's own.
// Client-side on purpose: PolicyApplicationCardComponent also renders once
// per board move and broadcasts that markup to every connected viewer over
// ActionCable (see BroadcastBackofficeMove), so a server-computed class
// would be wrong for everyone except whoever triggered the move. A
// MutationObserver re-applies it as cards arrive/leave, the same approach
// kanban_search_controller uses for the same reason.
export default class extends Controller {
  static values = { currentUserId: String }

  connect() {
    this.observer = new MutationObserver(() => this.apply())
    this.observer.observe(this.element, { childList: true, subtree: true })
    this.apply()
  }

  disconnect() {
    this.observer.disconnect()
  }

  apply() {
    this.element.querySelectorAll(".policy-application-card").forEach((card) => {
      const badge = card.querySelector(".policy-application-card__case-worker")
      if (!badge) return

      const mine = card.dataset.caseWorkerId === this.currentUserIdValue
      badge.classList.toggle("policy-application-card__case-worker--mine", mine)
    })
  }
}
